module.exports = __webpack_public_path__ + "img/silentswap.ab681390.svg";